<template lang="pug">
  .add-wa-form
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text Sort Products
        v-divider.basic300

        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

        v-card-text.pa-0(v-else)
          div.my-3
            div.text-center.pb-2.mx-2
              div.c1.mb-2.primary400--text Drag and drop the
                ArrowsSortIcon.mx-1.mb-n1(size="16" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                | icon to rearrange the products
            draggable(tag="div" :list="products" handle=".handle" @start="drag=true"  @end="drag=false")
              template(v-for="(element, idx) in products")
                v-card.px-2(flat :class="{ 'drag-active': drag }" style="border-bottom:1px solid var(--v-basic300); border-radius:0")
                  v-list-item.px-3
                    v-list-item-action.my-0.mr-3
                      template
                        v-avatar.caption(color="grey lighten-2" size="20") {{ idx + 1 }}
                    v-list-item-content {{ element.name }}
                    v-list-item-icon.my-auto.ml-1.handle(:class="{ 'drag-inactive': !drag }")
                      ArrowsSortIcon.mx-1.mb-n1(size="20" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text Save

</template>

<script>
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
export default {
  name: 'SortCategoryProduct',
  props: ['open', 'company', 'category'],
  components: { draggable },
  data: () => ({
    isFetching: true,
    products: [],
    isLoading: false,
    drag: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchProducts () {
      this.$axios.get(`/product_categories/${this.category.id}/products/?page_size=-1`)
        .then(resp => {
          this.products = resp.data.results
          this.isFetching = false
        })
        .catch(() => {})
    },
    clickSave() {
      this.isLoading = true
      let data = {
        products: this.products.map(m => { return m.id })
      }
      this.axios.patch(`/product_categories/${this.category.id}/`, data)
        .then(() => {
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>

<style scoped>
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
.handle {
  /* float: left; */
  padding: 8px 0 8px 8px;
}
</style>
